<template>

<div class="">

<!-- <FinancialData/>  -->


<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Debit Student Charges</div> 
<div class="panal-body">


    <div class="table-responsive">
               <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Charge Name</th>
                    <th scope="col">Value</th>
                    <th scope="col">Due Date</th>
                     <th scope="col">Charge Status</th>
                     <!-- <th scope="col">Semester </th> -->
                      <th scope="col" hidden>Payment_Ins.ID </th>
                     <th scope="col"> </th>

                  </tr>
                </thead>
                <tbody>
                   <tr v-if="empty"><td colspan="7"> No Data </td></tr>
                  <tr v-else v-for="item in pagedCharges" v-bind:Key="item.StudentID">
                   
                    <td>
                      {{item.ChargeName}}
                    </td>
                    
                    <td >
                          {{item.Value | toCurrency}}
                      
                    </td>
                    <td>
                       {{item.DueDate}}
                    </td>
                    <td >

                          {{item.ChargeStatus}}

                    </td>
                    <!-- <td > 

                      {{item.Semester}}
                    </td> -->
                    <td hidden> 

                      {{item.Payment_InstallmentID}}
                    </td>
                    <!-- v-b-modal.modal-lg -->
                     <td >  <b-button  variant="success" v-bind:key="item.Payment_InstallmentID"  @click="getdit(item, item.Payment_InstallmentID)" 
                        >View Details </b-button></td>
                  </tr>
       

                </tbody>
              </table>

                   <p>
<button @click="prevPage" class="btn btn-primary" :disabled="currentPage == 1">{{currentPage == 1 ? 'First' : 'previous'}}</button> 
    {{currentPage }} of {{(DebitCharges.length / pageSize).toFixed()}}
<button class="btn btn-primary" @click="nextPage" :disabled="currentPage == (DebitCharges.length / pageSize).toFixed()">{{currentPage == (DebitCharges.length / pageSize).toFixed() ? 'Last' : 'next'}}</button>
</p>        
</div>

 <b-modal id="modal-lg" size="lg" title="Debit Details" @hidden="clearClientInfo" ok-only>
                
<div class="table-responsive">
               <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Value To Pay</th>
                    <th scope="col">Payment Plan</th>
                    <th scope="col">Remain</th>
                     <!--  <th scope="col">Payment Date</th>-->
                     <th scope="col">Status </th>
                     <th scope="col">Last Due Date </th>
                    

                  </tr>
                </thead>
                <tbody>
                   <tr v-if="InstallmentID.length == 0">
                    <td colspan="7">No Data</td>
                  </tr>
                  <tr v-else
                    v-for="item in InstallmentID"
                    v-bind:Key="item.Payment_InstallmentID">
                   
                    <td>{{item.ValueToPay | toCurrency}}</td>
                    
                    <td >{{item.PaymentPlan}}</td>
                  
                    <td >{{item.Remain}}</td>
                    <!--   <td>20-12-2020</td> -->
                    <td >  {{item.PaymentStatus}} </td>
                     <td >  {{item.LastDueDate}} </td>
                   
                  </tr>
       

                </tbody>
              </table>

              
</div>
                
              </b-modal>



</div>
</div>
</div>
</div>


<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Credit Student Charges</div> 
<div class="panal-body">


    <div class="table-responsive">
               <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Charge Name</th>
                    <th scope="col">Value</th>
                    <th scope="col">Due Date</th>
                     <th scope="col">Charge Status</th>
                  <!--   <th scope="col">Semester </th>-->
                    

                  </tr>
                </thead>
                <tbody>
                   <tr v-if="empty">
                    <td colspan="7">No Data</td>
                  </tr>
                  <tr v-else
                    v-for="item in pagedChargesCredit"
                    v-bind:Key="item.StudentID">
                   
                    <td>{{item.ChargeName}}</td>
                    
                    <td >{{item.Value | toCurrency}}</td>
                    <td>{{item.DueDate}}</td>
                    <td >{{item.ChargeStatus}}</td>
                    <!-- <td >  ....... </td>-->
                   
                  </tr>
       

                </tbody>
              </table>

               <p>
<button @click="prevPageCredit" class="btn btn-primary" :disabled="currentPageCredit == 1">{{currentPageCredit == 1 ? 'First' : 'previous'}}</button> 
    {{currentPageCredit }} of {{(CreditCharges.length / pageSizeCredit).toFixed()}}
<button class="btn btn-primary" @click="nextPageCredit" :disabled="currentPageCredit == (CreditCharges.length / pageSizeCredit).toFixed()">{{currentPage == (DebitCharges.length / pageSize).toFixed() ? 'Last' : 'next'}}</button>
</p>

              
</div>

</div>
</div>
</div>
</div>

</div>
</template>
<script>
// import FinancialData from "../../components/Financial/FinancialData.vue";
import studentData from '../../services/student/studentDataServices';
    export default {
       components: {
      // FinancialData,
  
               },
  
        name: 'Charges',
          data() {
      return {
        selected: null,
        show: true,
        isHidden: false,
        DebitCharges: [],
        ChargesAdvanced:'',
        InstallmentID:'',
        CreditCharges:[],
        Payment_InstallmentID:'',
        currentItem:"",
         model:'',
        empty: false,
          pageSize:5,
          currentPage:1, 

          pageSizeCredit:5,
          currentPageCredit:1
        
      }
      
    },
    computed:{
           currenUser(){
            return  this.$store.state.auth.user
          },
            pagedCharges(){
             return this.DebitCharges.map(item => item).filter((row, index) => {
		let start = (this.currentPage-1)*this.pageSize;
		let end = this.currentPage*this.pageSize;
		if(index >= start && index < end) return true;
	});
            }, 

             pagedChargesCredit(){
             return this.CreditCharges.map(item => item).filter((row, index) => {
              let start = (this.currentPageCredit-1)*this.pageSizeCredit;
              let end = this.currentPageCredit*this.pageSizeCredit;
              if(index >= start && index < end) return true;
            });
            }

       },

       methods:{
    getdit(item, Payment_InstallmentID){
      
     // this.$bvModal.show(Payment_InstallmentID);
   
      
         this.currentItem  = item;
          
          
          //this.currenUser.StudentID,item.CourseID,item.RoleReviewID
          studentData.GetStudentDebitChargesAdvanced(item.StudentID, Payment_InstallmentID).then(
             (Response) => {
          this.isLoading = false;
          this.InstallmentID = Response.data;
          this.$bvModal.show("modal-lg")
          // eslint-disable-next-line no-console
         // console.log('StudentDebitChargesAdvanced => ',this.InstallmentID);
       
        },
        (error) => {
          // eslint-disable-next-line no-console
        //  console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      
          )
    },
     clearClientInfo() {
        this.InstallmentID = {}
      },
      
nextPage:function() {
  if((this.currentPage*this.pageSize) < this.DebitCharges.length) this.currentPage++;
},
prevPage:function() {
  if(this.currentPage > 1) this.currentPage--;
}, 
nextPageCredit:function() {
  if((this.currentPageCredit*this.pageSizeCredit) < this.DebitCharges.length) this.currentPageCredit++;
},
prevPageCredit:function() {
  if(this.currentPageCredit > 1) this.currentPageCredit--;
}

  },

     mounted(){
        
      //this.currenUser.StudentID  //4
            studentData.GetStudentDebitChargesBasic(this.currenUser.StudentID).then(Response =>{
              // this.isLoading = false ;
               this.DebitCharges = Response.data
                // eslint-disable-next-line no-console
               
                 // console.log('DebitChargesBasic',Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                //  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }),
            // 4 
            // 452
            studentData.GetStudentDebitChargesAdvanced(this.currenUser.StudentID,this.Payment_InstallmentID ).then(Response =>{
             
              // this.isLoading = false ;
             
               this.ChargesAdvanced = Response.data
               // this.empty =false
                // eslint-disable-next-line no-console
               //  console.log('ChargesAdvanced => ', Response.data)
           },
         error => {
              
                  // eslint-disable-next-line no-console
                  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }),
            // 240 // this.currenUser.StudentID
            studentData.GetStudentCreditChargesBasic(this.currenUser.StudentID).then(Response =>{
             
              // this.isLoading = false ;
             
               this.CreditCharges = Response.data
               // this.empty =false
                // eslint-disable-next-line no-console
                //  console.log('CreditCharges => ', Response.data)
           },
         error => {
              
                  // eslint-disable-next-line no-console
                //  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
     
     }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #ff8600;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

 .app-stu-photo {
    float: right;
    width: 200px;
    border-radius: 10px;
    border: 1px solid #111;
    margin-top: 20px;
  }

  .app-stu-photo img {
    width: 100%;
    border-radius: 10px;

  }

  .app-All {
    width: 75%;
    float: left;
  }

  .app-stu {
    border-bottom: 1px #333 dotted;
    padding: 10px 0px;
   
    float: left;

  }

  .app-stu .title {
    font-weight: bold;

  }

  .app-stu .title span {
    font-weight: 100;



  }

  .table .thead-dark th {
    color: #fff;
    background-color: #dee2e6 !important;
    border-color: #989899 !important;
    font-size: 13px !important;
  }
.table .thead-light th {
    color: #495057;
    background-color: #e9ecef;
    border-color: #dee2e6;
    font-size: 13px !important;
}

.bg-filter{
   background: #cacaca;
    padding: 10px;
    width:100%;
}
.show{
  display:none;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>
